"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var aws_amplify_1 = require("aws-amplify");
var aws_amplify_2 = require("aws-amplify");
var aws_exports_1 = require("../config/aws-exports");
var constants_1 = require("../constants");
var model_1 = require("../model");
var auth_error_1 = require("../model/auth.error");
var auth_user_1 = require("../model/auth.user");
var user_info_1 = require("../model/user.info");
var user_session_1 = require("../model/user.session");
var parseCognitoUser = function (cognitoUser, config) { return __awaiter(void 0, void 0, void 0, function () {
    var userAttributes, attributesMap, subUserAttrb, usernameAttrb, userInfo_1, authUser;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, aws_amplify_1.Auth.userAttributes(cognitoUser)];
            case 1:
                userAttributes = _a.sent();
                attributesMap = config.provider.aws.userAttributeMap;
                subUserAttrb = userAttributes.find(function (attrb) { return attrb.getName() === 'sub'; });
                usernameAttrb = userAttributes.find(function (attrb) { return attrb.getName() === attributesMap.preferred_username; });
                if (subUserAttrb && usernameAttrb) {
                    userInfo_1 = {
                        preferred_username: usernameAttrb.getValue(),
                        profile: 'ACTIVE',
                        customAttributes: {}
                    };
                    userAttributes.forEach(function (userAttrb) {
                        if (userAttrb.getName() === 'sub') {
                            return;
                        }
                        // Check if key mapping is present in configuration
                        var keyMaps = Object.entries(attributesMap).filter(function (_a) {
                            var standardKey = _a[0], awsKey = _a[1];
                            return userAttrb.getName() === awsKey;
                        });
                        if (keyMaps.length !== 0) {
                            keyMaps.forEach(function (keyMap) {
                                var standardKey = keyMap[0], awsKey = keyMap[1];
                                userInfo_1[standardKey] = userAttrb.getValue();
                            });
                        }
                        // if no mapping then add it to custom attribute
                        else if (userInfo_1.customAttributes !== undefined) {
                            userInfo_1.customAttributes[userAttrb.getName()] = userAttrb.getValue();
                        }
                    });
                    authUser = new auth_user_1.default(userInfo_1.preferred_username, new user_info_1.UserInfo(subUserAttrb.getValue(), subUserAttrb.getValue(), userInfo_1));
                    return [2 /*return*/, authUser];
                }
                throw new Error('sub or userName attrb is missing');
        }
    });
}); };
var parseSignUpParams = function (params, config) {
    // Attrib mapping coniguration
    var attributesMap = config.provider.aws.userAttributeMap;
    // get the attributes only available in signup params using maps param key
    var filteredAttrbs = Object.entries(attributesMap).filter(function (_a) {
        var standardKey = _a[0], awsKey = _a[1];
        return params.hasOwnProperty(standardKey);
    });
    var attributes = {};
    Object.entries(params).forEach(function (_a) {
        var standardKey = _a[0], value = _a[1];
        var attrbKey = attributesMap.hasOwnProperty(standardKey)
            ? attributesMap[standardKey]
            : standardKey;
        if (standardKey !== 'preferred_username' &&
            standardKey !== 'password') {
            attributes[attrbKey] = value;
        }
    });
    return {
        username: String(params[attributesMap.preferred_username]),
        password: params.password,
        attributes: attributes
    };
};
var AWSAuthProvider = /** @class */ (function () {
    function AWSAuthProvider(config) {
        this.config = config;
    }
    /**
     * Get current authenticated user
     * @param params
     */
    AWSAuthProvider.prototype.currentAuthenticatedUser = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var cognitoUser, user;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, aws_amplify_1.Auth.currentAuthenticatedUser()];
                    case 1:
                        cognitoUser = _a.sent();
                        return [4 /*yield*/, parseCognitoUser(cognitoUser, this.config)];
                    case 2:
                        user = _a.sent();
                        console.log('currentAuthenticatedUser aws');
                        return [2 /*return*/, user];
                }
            });
        });
    };
    /**
     * Log In
     * @param username
     * @param password
     */
    AWSAuthProvider.prototype.signIn = function (username, password, locale) {
        return __awaiter(this, void 0, void 0, function () {
            var cognitoUser, user, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, aws_amplify_1.Auth.signIn(username, password)];
                    case 1:
                        cognitoUser = _a.sent();
                        if (cognitoUser === undefined) {
                            throw new Error('Invalid Credentials');
                        }
                        return [4 /*yield*/, parseCognitoUser(cognitoUser, this.config)];
                    case 2:
                        user = _a.sent();
                        return [2 /*return*/, user];
                    case 3:
                        e_1 = _a.sent();
                        console.log(JSON.stringify(e_1));
                        switch (e_1.code) {
                            case 'NotAuthorizedException':
                                throw new auth_error_1.default(constants_1.AuthMessageEnum.INVALID_CREDENTIAL, constants_1.ErrorCodeEnum.INVALID_CREDENTIAL);
                            case 'UserNotConfirmedException':
                                throw new auth_error_1.default(constants_1.AuthMessageEnum.PENDING_VERIFICATION, constants_1.ErrorCodeEnum.PENDING_VERIFICATION);
                            case constants_1.ErrorCodeEnum.PENDING_CHANGE_PASSWORD:
                                throw new auth_error_1.default(constants_1.AuthMessageEnum.PENDING_VERIFICATION, constants_1.ErrorCodeEnum.PENDING_CHANGE_PASSWORD);
                            case constants_1.ErrorCodeEnum.MISSING_PARAMETER:
                                throw new auth_error_1.default(constants_1.AuthMessageEnum.MISSING_PARAMETER, constants_1.ErrorCodeEnum.PENDING_CHANGE_PASSWORD);
                            case constants_1.ErrorCodeEnum.LOCKED:
                                throw new auth_error_1.default(constants_1.AuthMessageEnum.LOCKED, constants_1.ErrorCodeEnum.LOCKED);
                            default:
                                throw e_1;
                        }
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * logout
     */
    AWSAuthProvider.prototype.signOut = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, aws_amplify_1.Auth.signOut()];
            });
        });
    };
    /**
     * Sign up with username, password and other attributes like phone, email
     * @param params
     */
    AWSAuthProvider.prototype.signUp = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var awsSignupParam, awsResult, e_2, signupResult;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        awsSignupParam = parseSignUpParams(params, this.config);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, aws_amplify_1.Auth.signUp(awsSignupParam)];
                    case 2:
                        awsResult = _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        e_2 = _a.sent();
                        switch (e_2.code) {
                            case 'UsernameExistsException':
                                throw new auth_error_1.default(constants_1.AuthMessageEnum.USER_ALREADY_EXISTS, constants_1.ErrorCodeEnum.USER_ALREADY_EXISTS);
                            case 'InvalidPasswordException':
                                throw new auth_error_1.default(constants_1.AuthMessageEnum.WEAK_PASSWORD, constants_1.ErrorCodeEnum.WEAK_PASSWORD);
                            case 'CodeDeliveryFailureException':
                                throw new auth_error_1.default(constants_1.AuthMessageEnum.INVALID_EMAIL_FORMAT, constants_1.ErrorCodeEnum.INVALID_EMAIL_FORMAT);
                            case 'InvalidParameterException':
                                if (e_2.message === 'Invalid email address format.') {
                                    throw new auth_error_1.default(constants_1.AuthMessageEnum.INVALID_EMAIL_FORMAT, constants_1.ErrorCodeEnum.INVALID_EMAIL_FORMAT);
                                }
                                if (e_2.message === 'Invalid phone number format.') {
                                    throw new auth_error_1.default(constants_1.AuthMessageEnum.INVALID_PHONE_NUMBER_FORMAT, constants_1.ErrorCodeEnum.INVALID_PHONE_NUMBER_FORMAT);
                                }
                                if (e_2.message.includes("Value at 'password'")) {
                                    throw new auth_error_1.default(constants_1.AuthMessageEnum.WEAK_PASSWORD, constants_1.ErrorCodeEnum.WEAK_PASSWORD);
                                }
                            default:
                                throw e_2;
                        }
                        return [3 /*break*/, 4];
                    case 4:
                        signupResult = {
                            sub: awsResult.userSub,
                            preferred_username: awsResult.user.getUsername(),
                            isUserConfirmed: awsResult.userConfirmed,
                            codeDelivery: []
                        };
                        return [2 /*return*/, signupResult];
                }
            });
        });
    };
    /**
     * Send the verfication code to confirm sign up
     * @param username
     * @param code
     */
    AWSAuthProvider.prototype.confirmSignUp = function (
    // tslint:disable-next-line: variable-name
    preferred_username, code, transactionId) {
        return __awaiter(this, void 0, void 0, function () {
            var e_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, aws_amplify_1.Auth.confirmSignUp(preferred_username, code)];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        e_3 = _a.sent();
                        switch (e_3.code) {
                            case 'CodeMismatchException':
                                throw new auth_error_1.default(constants_1.AuthMessageEnum.INVALID_PWD_RESET_CODE, constants_1.ErrorCodeEnum.INVALID_PWD_RESET_CODE);
                            default:
                                throw e_3;
                        }
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Initiate a forgot password request
     * @param username
     */
    AWSAuthProvider.prototype.forgotPassword = function (userName) {
        return __awaiter(this, void 0, void 0, function () {
            var result, delivery;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, aws_amplify_1.Auth.forgotPassword(userName)];
                    case 1:
                        result = _a.sent();
                        delivery = {
                            attributeName: result.AttributeName,
                            deliveryMedium: result.DeliveryMedium,
                            destination: result.Destination
                        };
                        return [2 /*return*/, delivery];
                }
            });
        });
    };
    /**
     * Request to resend the verification code
     * @param userName
     */
    AWSAuthProvider.prototype.resendSignUp = function (userName) {
        return __awaiter(this, void 0, void 0, function () {
            var result, delivery;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, aws_amplify_1.Auth.resendSignUp(userName)];
                    case 1:
                        result = _a.sent();
                        delivery = {
                            attributeName: 'email',
                            deliveryMedium: 'EMAIL',
                            destination: 's**#gamil.com'
                        };
                        return [2 /*return*/, delivery];
                }
            });
        });
    };
    /**
     * Change password by authenticated user
     * @param user
     * @param oldPassword
     * @param newPassword
     */
    AWSAuthProvider.prototype.changePassword = function (user, oldPassword, newPassword) {
        return __awaiter(this, void 0, void 0, function () {
            var cognitoUser, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        cognitoUser = aws_amplify_1.Auth.currentAuthenticatedUser();
                        return [4 /*yield*/, aws_amplify_1.Auth.changePassword(cognitoUser, oldPassword, newPassword)];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result];
                }
            });
        });
    };
    /**
     * Confirm a new password using a confirmation Code
     * @param username
     * @param code
     * @param password
     */
    AWSAuthProvider.prototype.forgotPasswordSubmit = function (username, code, password) {
        return __awaiter(this, void 0, void 0, function () {
            var e_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, aws_amplify_1.Auth.forgotPasswordSubmit(username, code, password)];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        e_4 = _a.sent();
                        switch (e_4.code) {
                            case 'CodeMismatchException':
                                throw new auth_error_1.default(constants_1.AuthMessageEnum.INVALID_PWD_RESET_CODE, constants_1.ErrorCodeEnum.INVALID_PWD_RESET_CODE);
                            case 'InvalidPasswordException':
                                throw new auth_error_1.default(constants_1.AuthMessageEnum.WEAK_PASSWORD, constants_1.ErrorCodeEnum.WEAK_PASSWORD);
                            case 'InvalidParameterException':
                                throw new auth_error_1.default(constants_1.AuthMessageEnum.WEAK_PASSWORD, constants_1.ErrorCodeEnum.WEAK_PASSWORD);
                            default:
                                throw e_4;
                        }
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/, 'SUCCESS'];
                }
            });
        });
    };
    /**
     * Get current user's session
     */
    AWSAuthProvider.prototype.currentSession = function () {
        return __awaiter(this, void 0, void 0, function () {
            var cognitoUser, session, idToken, accessToken;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, aws_amplify_1.Auth.currentAuthenticatedUser()];
                    case 1:
                        cognitoUser = _a.sent();
                        session = cognitoUser.getSignInUserSession();
                        if (session != null) {
                            idToken = session.getAccessToken().getJwtToken();
                            accessToken = session.getAccessToken().getJwtToken();
                            return [2 /*return*/, new user_session_1.default(new model_1.JWTToken(idToken), new model_1.JWTToken(accessToken), ' ')];
                        }
                        else {
                            throw new auth_error_1.default(constants_1.AuthMessageEnum.USER_NOT_LOGGEDIN, constants_1.ErrorCodeEnum.USER_NOT_LOGGEDIN);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     *
     * @param user Update user attributes
     * @param attributes
     */
    AWSAuthProvider.prototype.updateUserAttributes = function (user, attributes) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, 'SUCCESS'];
            });
        });
    };
    return AWSAuthProvider;
}());
var awsAuthProvider;
var createAWSProvider = function (config) {
    if (awsAuthProvider === undefined) {
        configureAWS(config);
        awsAuthProvider = new AWSAuthProvider(config);
    }
    return awsAuthProvider;
};
var configureAWS = function (config) {
    aws_amplify_2.default.configure(aws_exports_1.default);
};
exports.default = createAWSProvider;
//# sourceMappingURL=aws.auth.provider.js.map